(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {
	
	// var
	var $markers = $el.find('.marker');
	
	
	// vars
	var args = {
		zoom		: 12,
		center		: new google.maps.LatLng(0, 0),
		mapTypeId	: google.maps.MapTypeId.ROADMAP,
		disableDefaultUI: true,
		zoomControl: false, 
		scrollwheel: false,
		styles 		: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"color":"#ff0000"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#516b60"},{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"labels.text.fill","stylers":[{"color":"#516b60"},{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"geometry","stylers":[{"visibility":"off"},{"color":"#dce1df"}]},{"featureType":"administrative.locality","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#516b60"}]},{"featureType":"administrative.neighborhood","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#dce1df"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#edf0ef"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#516b60"},{"visibility":"on"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#e400ff"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#dce1df"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"##000000"},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"},{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#516b60"},{"visibility":"on"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"},{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#a8b5af"},{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#516b60"},{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"lightness":"0"},{"saturation":"0"},{"visibility":"on"},{"color":"#dce1df"}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}]
	};
	
	
	// create map	        	
	var map = new google.maps.Map( $el[0], args);
	
	
	// add a markers reference
	map.markers = [];
	
	
	// add markers
	$markers.each(function(){
		
    	add_marker( $(this), map );
		
	});
	
	
	// center map
	center_map( map );
	
	
	// return
	return map;
	
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
		icon		: 'data:image/png;base64,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'
	});

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 13 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

	$('.acf-map').each(function(){

		// create map
		map = new_map( $(this) );

	});

});

})(jQuery);